export const eventNameToSpanName = (eventName: string) => {
  return eventName
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) =>
      group.toUpperCase().replace("-", "").replace("_", ""),
    );
};
